<template>
    <div style="padding: 20px; height: calc(100vh - 180px); overflow-y: auto;">
        <div class="page_header">
            <span class="page_title"></span>
            <el-form :inline="true" :model="searchForm" size="small" style="flex:1;text-align: right;">
                <el-form-item :label="$t('statistics.fuelType')">
                    <el-select v-model="searchForm.fuelType" style="width: 120px;">

                        <el-option v-for="item in energyTypes" :key="item" :label="getEnergyName(item)" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('time.timeQuery')">
                    <el-select v-model="searchForm.timeType" style="width: 100px;" @change="handleTimeTypeChange">
                        <el-option :label="$t('time.按日')" value="day"></el-option>
                        <el-option :label="$t('time.按月')" value="month"></el-option>
                        <el-option :label="$t('time.按年')" value="year"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-if="searchForm.timeType === 'day'" v-model="searchForm.dateRange" type="daterange"
                        :range-separator="$t('time.to')" :start-placeholder="$t('time.startDate')"
                        :end-placeholder="$t('time.endDate')" value-format="yyyy-MM-dd" style="width: 280px;"
                        :picker-options="datePickerOptions">
                    </el-date-picker>
                    <el-date-picker v-if="searchForm.timeType === 'month'" v-model="searchForm.monthRange"
                        type="monthrange" :range-separator="$t('time.to')" :start-placeholder="$t('time.startMonth')"
                        :end-placeholder="$t('time.endMonth')" value-format="yyyy-MM" style="width: 280px;">
                    </el-date-picker>
                    <el-date-picker v-if="searchForm.timeType === 'year'" v-model="searchForm.yearRange" type="year"
                        :placeholder="$t('time.选择年份')" value-format="yyyy" style="width: 140px;">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleQuery">{{ $t('public.query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" plain @click="handleExport">{{ $t('public.export') }}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-divider></el-divider>
        <div>
            <div class="chart_container">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div class="chart_card">
                            <div class="chart_title">{{ $t('statistics.燃耗排行') }}</div>
                            <div id="rankingChart" style="width: 100%;height: 350px;"></div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="chart_card">
                            <div class="chart_title">{{ $t('statistics.燃耗/里程对比') }}</div>
                            <div id="comparisonChart" style="width: 100%;height: 350px;"></div>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="table_container">
                <div class="table_title">{{ $t('statistics.燃耗明细') }}</div>
                <el-table :data="paginatedTableData" v-loading="loading" stripe style="width: 100%;">
                    <el-table-column prop="carNo" align="center" :label="$t('vehicle.carNo')"
                        min-width="120"></el-table-column>
                    <el-table-column prop="manufactureNo" align="center" :label="$t('vehicle.ManufactureNo')"
                        min-width="100"></el-table-column>
                    <el-table-column prop="fuelType" align="center" :label='$t("statistics.fuelType")'
                        min-width="100"></el-table-column>
                    <el-table-column prop="totalRunTime" align="center" :label='$t("statistics.runTime")'
                        min-width="100">
                        <template slot-scope="scope">
                            {{ timeChange(scope.row.totalRunTime) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalOverIdleDuration" align="center" :label='$t("statistics.怠速时长")'
                        min-width="100">
                        <template slot-scope="scope">
                            {{ timeChange(scope.row.totalOverIdleDuration) }}
                        </template>
                    </el-table-column>

                    <el-table-column prop="avgSpeed" align="center" :label='$t("statistics.avgSpeed")'
                        min-width="120"></el-table-column>
                    <el-table-column prop="totalMileage" align="center" :label='$t("statistics.mileage")'
                        min-width="120"></el-table-column>


                    <el-table-column prop="totalOilConsumption"
                        v-if="searchForm.fuelType == 1 || searchForm.fuelType == 3" align="center"
                        :label="$t('statistics.oilConsume')" min-width="120">
                        <template slot-scope="scope">
                            {{ scope.row.totalOilConsumption }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="avgOilPer100km" v-if="searchForm.fuelType == 1 || searchForm.fuelType == 3"
                        align="center" :label="$t('runState.perOilConsume')" min-width="150">
                        <template slot-scope="scope">
                            {{ scope.row.avgOilPer100km }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalGasConsumption"
                        v-if="searchForm.fuelType == 2 || searchForm.fuelType == 4" align="center"
                        :label="$t('statistics.气耗') + '(' + gasUnit + ')'" min-width="120">
                        <template slot-scope="scope">
                            {{ scope.row.totalGasConsumption }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="avgGasPer100km" v-if="searchForm.fuelType == 2 || searchForm.fuelType == 4"
                        align="center" :label="$t('statistics.百公里耗气') + '(' + gasUnit + ')'" min-width="150">
                        <template slot-scope="scope">
                            {{ scope.row.avgGasPer100km }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalPowerConsumption"
                        v-if="searchForm.fuelType == 3 || searchForm.fuelType == 4 || searchForm.fuelType == 5 || searchForm.fuelType == 6"
                        align="center" :label='$t("statistics.powerConsumption")' min-width="120">
                        <template slot-scope="scope">
                            {{ scope.row.totalPowerConsumption }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="consumptionPer100km"
                        v-if="searchForm.fuelType == 3 || searchForm.fuelType == 4 || searchForm.fuelType == 5 || searchForm.fuelType == 6"
                        align="center" :label='$t("statistics.powerConsumptionPer100km")' min-width="150">
                        <template slot-scope="scope">
                            {{ scope.row.avgPowerPer100km }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalHydrogenConsumption" v-if="searchForm.fuelType == 6" align="center"
                        :label="$t('statistics.耗氢量')" min-width="120">
                        <template slot-scope="scope">
                            {{ scope.row.totalHydrogenConsumption }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="avgHydrogenPer100km" v-if="searchForm.fuelType == 6" align="center"
                        :label="$t('statistics.百公里耗氢')" min-width="150">
                        <template slot-scope="scope">
                            {{ scope.row.avgHydrogenPer100km }}
                        </template>
                    </el-table-column>

                </el-table>
                <el-pagination style="margin-top: 20px; text-align: right;" :current-page="pagination.currentPage"
                    :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize" :total="pagination.total"
                    layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { convertGasUnit } from "@/utils/longyi";
export default {
    name: 'EnergyConsumptionSummary',
    components: {
    },
    computed: {
        ...mapState({
            selectedVehicles: state => state.app.vehicles.selectedVehicles,
        }),
        energyTypes() {
            // return [1, 2, 3, 4, 5, 6]
            return this.$store.getters.energyTypes;
        },
        gasUnit() {
            if (this.$store.getters.gasUnit == "m3") return "m³";
            return this.$store.getters.gasUnit;
        },
        // 前端分页数据（按 totalRunTime 降序排列）
        paginatedTableData() {
            const { currentPage, pageSize } = this.pagination;
            const sorted = [...this.tableData].sort((a, b) => (b.totalRunTime || 0) - (a.totalRunTime || 0));
            const start = (currentPage - 1) * pageSize;
            const end = start + pageSize;
            return sorted.slice(start, end);
        },
        // 昨天的日期
        yesterday() {
            const date = new Date();
            date.setDate(date.getDate() - 1);
            return date;
        },
    },
    data() {
        return {
            searchForm: {
                fuelType: this.$store.getters.energyTypes[0],
                timeType: 'day',
                dateRange: (function () {
                    const endDate = new Date();
                    endDate.setDate(endDate.getDate() - 1); // 昨天
                    const startDate = new Date();
                    startDate.setDate(startDate.getDate() - 7); // 最近7天（到昨天）

                    // 格式化为 yyyy-MM-dd
                    const formatDate = (date) => {
                        const year = date.getFullYear();
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const day = String(date.getDate()).padStart(2, '0');
                        return `${year}-${month}-${day}`;
                    };

                    return [formatDate(startDate), formatDate(endDate)];
                })(),
                monthRange: (function () {
                    const endDate = new Date();
                    const startDate = new Date();
                    startDate.setMonth(startDate.getMonth() - 2); // 最近3个月

                    // 格式化为 yyyy-MM
                    const formatMonth = (date) => {
                        const year = date.getFullYear();
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        return `${year}-${month}`;
                    };

                    return [formatMonth(startDate), formatMonth(endDate)];
                })(),
                yearRange: (function () {
                    // 默认为今年
                    return new Date().getFullYear().toString();
                })()
            },
            loading: false,
            tableData: [],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            rankingChart: null,
            comparisonChart: null,
            // 日期选择器选项
            datePickerOptions: {
                disabledDate: (time) => {
                    const yesterday = new Date();
                    yesterday.setDate(yesterday.getDate() - 1);
                    return time.getTime() > yesterday.getTime();
                }
            }
        }
    },
    mounted() {
        this.initCharts();
        this.loadData();

        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        if (this.rankingChart) {
            this.rankingChart.dispose();
        }
        if (this.comparisonChart) {
            this.comparisonChart.dispose();
        }
    },
    methods: {
        timeChange(s) {
            if (s == null || s == 0) return "0";
            let day, hour, minute, second;
            day = parseInt(s / 3600 / 24) == 0 ? "" : parseInt(s / 3600 / 24) + this.$t("statistics.day");
            hour = parseInt(s / 3600 % 24) == 0 ? "" : parseInt(s / 3600 % 24) + this.$t("statistics.小时");
            minute = parseInt(s / 60 % 60) == 0 ? "" : parseInt(s / 60 % 60) + this.$t("statistics.分");
            second = parseInt(s % 60) == 0 ? "" : parseInt(s % 60) + this.$t("statistics.秒");
            // console.log(s,day,hour,minute,second,);
            return day + hour + minute + second;
        },
        getEnergyName(energyType) {
            if (energyType == 1) {
                return this.$t('oiltype.caiyouji');
            } else if (energyType == 2) {
                return this.$t('oiltype.qitiji');
            } else if (energyType == 3) {
                return this.$t('oiltype.youdain');
            } else if (energyType == 4) {
                return this.$t('oiltype.qidian');
            } else if (energyType == 5) {
                return this.$t('oiltype.chundiandong');
            } else if (energyType == 6) {
                return this.$t('oiltype.ranliao');
            }
            return '';
        },
        getSelectedVehicles() {
            let vehicles = "";
            for (let k = 0; k < this.selectedVehicles.length; k++) {
                if (this.selectedVehicles[k].treeLevel == 5) {
                    vehicles = vehicles + this.selectedVehicles[k].nodeValue + ",";
                }
            }
            return vehicles.substring(0, vehicles.length - 1);
        },
        getEnergyUnit(fuelType) {
            const unitMap = {
                '1': 'L',
                '2': 'm³',
                '3': 'L',
                '4': this.gasUnit,
                '5': 'kW·h',
                '6': 'kg'
            };
            return unitMap[fuelType] || '';
        },
        handleTimeTypeChange() {

        },
        initCharts() {
            this.rankingChart = echarts.init(document.getElementById('rankingChart'));
            this.comparisonChart = echarts.init(document.getElementById('comparisonChart'));
        },
        handleResize() {
            if (this.rankingChart) {
                this.rankingChart.resize();
            }
            if (this.comparisonChart) {
                this.comparisonChart.resize();
            }
        },
        handleQuery() {
            this.pagination.currentPage = 1;
            this.loadData();
        },
        handleExport() {

            //前端导出功能


            //换一种导出 
            var fileName = this.$t("statistics.燃耗总览");
            import('../../statistics/components/Export2Excel').then(excel => {
                let tHeader = [this.$t("vehicle.carNo"), this.$t("vehicle.ManufactureNo"), this.$t("statistics.fuelType"), this.$t("statistics.runTime"), this.$t("statistics.怠速时长"), this.$t("statistics.avgSpeed"), this.$t("statistics.mileage")

                ];
                //根据选择的类型，导出不同的数据




                let filterVal = ["carNo",
                    "manufactureNo", "fuelType", "totalRunTime", "totalOverIdleDuration",
                    "avgSpeed",
                    "totalMileage",

                ]

                switch (this.searchForm.fuelType) {
                    case "1":

                        tHeader.push(this.$t('statistics.oilConsume'), this.$t('runState.perOilConsume'));
                        filterVal.push("totalOilConsumption", "avgOilPer100km");
                        break;
                    case "2":
                        tHeader.push(this.$t('statistics.气耗') + '(' + this.gasUnit + ')', this.$t('statistics.百公里耗气') + '(' + this.gasUnit + ')');
                        filterVal.push("totalGasConsumption", "avgGasPer100km");
                        break;
                    case "3":
                        tHeader.push(this.$t('statistics.oilConsume'), this.$t('runState.perOilConsume'));
                        filterVal.push("totalOilConsumption", "avgOilPer100km");
                        tHeader.push(this.$t("statistics.powerConsumption"), this.$t("statistics.powerConsumptionPer100km"));
                        filterVal.push("totalPowerConsumption", "avgPowerPer100km");
                        break;
                    case "4":
                        tHeader.push(this.$t('statistics.气耗') + '(' + this.gasUnit + ')', this.$t('statistics.百公里耗气') + '(' + this.gasUnit + ')');
                        filterVal.push("totalGasConsumption", "avgGasPer100km");
                        tHeader.push(this.$t("statistics.powerConsumption"), this.$t("statistics.powerConsumptionPer100km"));
                        filterVal.push("totalPowerConsumption", "avgPowerPer100km");
                        break;
                    case "5":
                        tHeader.push(this.$t("statistics.powerConsumption"), this.$t("statistics.powerConsumptionPer100km"));
                        filterVal.push("totalPowerConsumption", "avgPowerPer100km");
                        break;
                    case "6":
                        tHeader.push(this.$t('statistics.耗氢量'), this.$t('statistics.百公里耗氢'));
                        filterVal.push("totalHydroConsumption", "avgHydrogenPer100km");
                        break;

                    default:
                        break;
                }
                // switch (this.searchForm.timeType) {
                //     case "day":
                //         fileName = this.$t("statistics.日燃耗总览");
                //         break;
                //     case "month":
                //         fileName = this.$t("statistics.月燃耗总览");
                //         break;
                //     case "year":
                //         fileName = this.$t("statistics.年燃耗总览");
                //         break;
                // }


                const list = this.tableData
                // list.forEach(item => {
                // 	item.startDate = this.form.beginDate ;
                // 	item.endDate = this.form.endDate;
                // 	item.carNo = item.carNo == '小结' ? this.$t("runState.tableSum") : item.carNo;
                // })
                const data = this.formatJson(filterVal, list)
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: fileName,
                    autoWidth: this.autoWidth,
                    bookType: this.bookType
                })
            })

        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => {
                switch (j) {

                    case "totalRunTime":
                    case "totalOverIdleDuration":
                        return this.timeChange(v[j]);
                    default:
                        return v[j] == null ? 0 : v[j];
                }
            }))
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val;
            // 前端分页，不需要重新加载数据
        },
        handleCurrentChange(val) {
            this.pagination.currentPage = val;
            // 前端分页，不需要重新加载数据
        },
        loadData() {
            this.loading = true;


            //根据选择的类型，计算查询时间
            let beginDate = this.searchForm.dateRange[0],
                endDate = this.searchForm.dateRange[1];
            if (this.searchForm.timeType == 'day') {
                //格式化为yyyy-MM-dd
                beginDate = this.moment(this.searchForm.dateRange[0]).format('YYYY-MM-DD');
                endDate = this.moment(this.searchForm.dateRange[1]).format('YYYY-MM-DD');
            }
            else if (this.searchForm.timeType == 'month') {
                beginDate = this.moment(this.searchForm.monthRange[0]).format('YYYY-MM-01');

                //获取到选中月份的最后一天
                endDate = this.moment(this.searchForm.monthRange[1]).endOf('month').format('YYYY-MM-DD');
            }
            else if (this.searchForm.timeType == 'year') {
                beginDate = this.moment(this.searchForm.yearRange + '-01-01').format('YYYY-MM-DD');
                //获取到选中年份的最后一天                
                endDate = this.moment(this.searchForm.yearRange + '-12-31').endOf('year').format('YYYY-MM-DD');
            }

            console.log(beginDate, endDate);

            let vehicles = this.getSelectedVehicles();

            //从接口获取数据,单车，多车，全部车辆
            this.$api
                .energyInfo({
                    "companyID": this.$store.getters.operator.CompanyId,
                    "vehicles": vehicles,
                    "queryType": this.searchForm.timeType == 'day' ? 1 : this.searchForm.timeType == 'month' ? 0 : 2, "beginDate": beginDate, "endDate": endDate,
                    "OperatorID": this.$store.getters.operator.OperatorId,
                    "PageNo": 1, "PageSize": 65530,
                    "IsExport": 0,
                    "Language": this.$store.getters.LanguageId,
                    "CompanyFlag": 0,
                    "Unit": this.gasUnit == 'm³' ? 'm3' : this.gasUnit,
                }).then(res => {
                    // console.log(res);

                    // 合并车辆数据
                    this.tableData = this.mergeCarDataByCarNo(res.data);


                    this.pagination.total = this.tableData.length;


                    const rankingData = [];
                    //todo 需要根据燃料类型选择具体数据
                    let energyType = this.searchForm.fuelType;
                    this.tableData.forEach(item => {
                        rankingData.push({
                            carNo: item.carNo,
                            energyConsumption: energyType == 1 ? item.totalOilConsumption : energyType == 2 ? item.totalGasConsumption : energyType == 3 ? item.totalHydrogenConsumption : energyType == 4 ? item.totalGasConsumption : energyType == 5 ? item.totalPowerConsumption : item.totalHydrogenConsumption
                        });
                    });

                    rankingData.sort((a, b) => b.energyConsumption - a.energyConsumption);
                    this.updateRankingChart(rankingData);

                    // 合并日期数据
                    var date_tableData = this.mergeByDate(res.data);
                    const comparisonData = [];
                    date_tableData.forEach(item => {
                        comparisonData.push({
                            date: item.date,
                            energyConsumption: energyType == 1 ? item.totalOilConsumption : energyType == 2 ? item.totalGasConsumption : energyType == 3 ? item.totalHydrogenConsumption : energyType == 4 ? item.totalGasConsumption : energyType == 5 ? item.totalPowerConsumption : item.totalHydrogenConsumption,
                            mileage: item.totalMileage
                        })
                    }
                    );

                    this.updateComparisonChart(comparisonData, "");


                    this.loading = false;
                });






        },

        /**
         * 按日期合并所有车辆数据
         * @param {Array} list 原始数据
         * @returns {Array} 按日期合并后的汇总数据
         */
        mergeByDate(list) {
            const group = {};

            list.forEach(item => {
                const date = item.statisticalTime;


                let exist = true;


                if (item.fuelType == this.$t("oiltype.caiyouji") && this.searchForm.fuelType != 1) {
                    exist = false;
                }
                if (item.fuelType == this.$t("oiltype.qitiji") && this.searchForm.fuelType != 2) {
                    exist = false;
                }
                if (item.fuelType == this.$t("oiltype.youdain") && this.searchForm.fuelType != 3) {
                    exist = false;
                }
                if (item.fuelType == this.$t("oiltype.qidian") && this.searchForm.fuelType != 4) {
                    exist = false;
                }
                if (item.fuelType == this.$t("oiltype.chundiandong") && this.searchForm.fuelType != 5) {
                    exist = false;
                }

                if (item.fuelType == this.$t("oiltype.ranliao") && this.searchForm.fuelType != 6) {
                    exist = false;
                }


                if (!group[date]) {
                    group[date] = {
                        date: date,
                        carCount: 0, // 当日车辆数
                        totalRunTime: 0,
                        totalMileage: 0,
                        totalPowerConsumption: 0,
                        totalOilConsumption: 0,
                        totalGasConsumption: 0,
                        totalHydrogenConsumption: 0,
                        totalAirConditionElec: 0,
                        totalOverIdleDuration: 0,

                    };
                }

                const day = group[date];
                if (day) {
                    day.totalRunTime += exist ? item.runTime || 0 : 0;
                    day.totalMileage += exist ? item.mileage || 0 : 0;
                    day.totalPowerConsumption += exist ? item.powerConsumption || 0 : 0;
                    day.totalAirConditionElec += exist ? item.AirConditionElecQuantity || 0 : 0;
                    day.totalOverIdleDuration += exist ? item.OverIdleDuration || 0 : 0;


                    day.totalOilConsumption += exist ? item.oilConsumption || 0 : 0;
                    day.totalGasConsumption += exist ? item.GasConsumption || 0 : 0;
                    day.totalHydrogenConsumption += exist ? item.HConsumption || 0 : 0;
                }
            });

            // 转数组并计算当日平均百公里电耗
            return Object.values(group).map(day => {
                const avgPowerPer100km = day.totalMileage > 0
                    ? Number((day.totalPowerConsumption / day.totalMileage * 100).toFixed(2))
                    : 0;

                //计算平均速度
                const avgSpeed = day.totalMileage > 0 && day.totalRunTime > 0
                    ? Number((day.totalMileage * 60 * 60 / day.totalRunTime).toFixed(2))
                    : 0;

                // 平均百公里油耗 = 总耗油量 / 总里程 * 100（保留2位小数）
                const avgOilPer100km = day.totalMileage > 0
                    ? Number((day.totalOilConsumption / day.totalMileage * 100).toFixed(2))
                    : 0;
                // 平均百公里耗氢量 = 总耗氢量 / 总里程 * 100（保留2位小数）
                const avgHydrogenPer100km = day.totalMileage > 0
                    ? Number((day.totalHydrogenConsumption / day.totalMileage * 100).toFixed(2))
                    : 0;
                // 平均百公里耗气量 = 总耗气量 / 总里程 * 100（保留2位小数）
                const avgGasPer100km = day.totalMileage > 0
                    ? Number((day.totalGasConsumption / day.totalMileage * 100).toFixed(2))
                    : 0;

                //总里程格式保留2位小数
                day.totalMileage = Number(day.totalMileage.toFixed(1));
                day.totalPowerConsumption = Number(day.totalPowerConsumption.toFixed(1));
                day.totalHydrogenConsumption = Number(day.totalHydrogenConsumption.toFixed(1));
                day.totalOilConsumption = Number(day.totalOilConsumption.toFixed(1));
                day.totalGasConsumption = Number(day.totalGasConsumption.toFixed(1));

                return {
                    ...day,
                    avgPowerPer100km,
                    avgSpeed,
                    avgOilPer100km,
                    avgHydrogenPer100km,
                    avgGasPer100km
                };
            });
        },
        /**
 * 按车牌号合并车辆数据
 * @param {Array} list 原始车辆日数据
 * @returns {Array} 合并后的车辆汇总数据
 */
        mergeCarDataByCarNo(list) {
            // 按 carNo 分组
            const group = {};
            list.forEach(item => {
                const key = item.carNo;

                let exist = true;


                if (item.fuelType == this.$t("oiltype.caiyouji") && this.searchForm.fuelType != 1) {
                    exist = false;
                }
                if (item.fuelType == this.$t("oiltype.qitiji") && this.searchForm.fuelType != 2) {
                    exist = false;
                }
                if (item.fuelType == this.$t("oiltype.youdain") && this.searchForm.fuelType != 3) {
                    exist = false;
                }
                if (item.fuelType == this.$t("oiltype.qidian") && this.searchForm.fuelType != 4) {
                    exist = false;
                }
                if (item.fuelType == this.$t("oiltype.chundiandong") && this.searchForm.fuelType != 5) {
                    exist = false;
                }

                if (item.fuelType == this.$t("oiltype.ranliao") && this.searchForm.fuelType != 6) {
                    exist = false;
                }
                if (!group[key] && exist) {
                    group[key] = {
                        carNo: item.carNo,
                        manufactureNo: item.manufactureNo,
                        DeviceNo: item.DeviceNo,
                        vid: item.vid,
                        fuelType: item.fuelType,
                        // 汇总字段

                        totalRunTime: 0, // 总运行时长
                        totalMileage: 0, // 总里程
                        totalElecPowerRunMileage: 0, // 总电耗里程
                        totalHydrogenPowerRunMileage: 0, // 总氢耗里程
                        totalGasPowerRunMileage: 0, // 总气耗里程
                        totalOilPowerRunMileage: 0, // 总油耗里程

                        totalPowerConsumption: 0, // 总耗电量
                        totalHydrogenConsumption: 0, // 总耗氢量
                        totalGasConsumption: 0, // 总耗气量
                        totalOilConsumption: 0, // 总耗油量    
                        totalAirConditionElec: 0, // 总空调耗电
                        totalOverIdleDuration: 0, // 总怠速时长

                    };
                }

                const car = group[key];
                if (car) {
                    car.totalRunTime += item.runTime || 0;
                    car.totalMileage += item.mileage || 0;
                    car.totalPowerConsumption += item.powerConsumption || 0;
                    car.totalAirConditionElec += item.AirConditionElecQuantity || 0;
                    car.totalOverIdleDuration += item.OverIdleDuration || 0;
                    car.totalHydrogenConsumption += item.HConsumption || 0;
                    car.totalGasConsumption += item.GasConsumption || 0;
                    car.totalOilConsumption += item.oilConsumption || 0;
                    car.totalElecPowerRunMileage += item.elecRunMileage || 0;
                    car.totalHydrogenPowerRunMileage += item.HRunmileage || 0;
                    car.totalGasPowerRunMileage += item.GasRunMileage || 0;
                    car.totalOilPowerRunMileage += item.oilRunMileage || 0;

                }
            });

            // 转数组并计算平均百公里电耗
            return Object.values(group).map(car => {
                // 平均百公里电耗 = 总耗电量 / 总里程 * 100（保留2位小数）
                const avgPowerPer100km = car.totalMileage > 0
                    ? Number((car.totalPowerConsumption / car.totalMileage * 100).toFixed(2))
                    : 0;
                //计算平均速度
                const avgSpeed = car.totalMileage > 0 && car.totalRunTime > 0
                    ? Number((car.totalMileage * 60 * 60 / car.totalRunTime).toFixed(2))
                    : 0;

                // 平均百公里油耗 = 总耗油量 / 总里程 * 100（保留2位小数）
                const avgOilPer100km = car.totalMileage > 0
                    ? Number((car.totalOilConsumption / car.totalMileage * 100).toFixed(2))
                    : 0;
                // 平均百公里耗氢量 = 总耗氢量 / 总里程 * 100（保留2位小数）
                const avgHydrogenPer100km = car.totalMileage > 0
                    ? Number((car.totalHydrogenConsumption / car.totalMileage * 100).toFixed(2))
                    : 0;
                // 平均百公里耗气量 = 总耗气量 / 总里程 * 100（保留2位小数）
                const avgGasPer100km = car.totalMileage > 0
                    ? Number((car.totalGasConsumption / car.totalMileage * 100).toFixed(2))
                    : 0;
                //总里程格式保留2位小数
                car.totalMileage = Number(car.totalMileage.toFixed(1));
                car.totalGasConsumption = Number(car.totalGasConsumption.toFixed(1));
                car.totalHydrogenConsumption = Number(car.totalHydrogenConsumption.toFixed(1));
                car.totalOilConsumption = Number(car.totalOilConsumption.toFixed(1));
                car.totalPowerConsumption = Number(car.totalPowerConsumption.toFixed(1));
               
                
                return {
                    ...car,
                    avgPowerPer100km,
                    avgSpeed,
                    avgOilPer100km,
                    avgHydrogenPer100km,
                    avgGasPer100km

                };
            });
        },


        updateRankingChart(data) {
            const xAxisData = data.map(item => item.carNo);
            const yAxisData = data.map(item => item.energyConsumption);

            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: xAxisData,
                    axisLabel: {
                        rotate: 45,
                        interval: 0
                    }
                },
                dataZoom: [
                    {
                        type: 'inside',
                        start: 0,
                        end:  this.tableData.length > 25 ? (25 / this.tableData.length) * 100 : 100,
                        zoomLock: false
                    },
                    {
                        show: true,
                        type: 'slider',
                        bottom: 5,
                        start: 0,
                        end:  this.tableData.length > 25 ? (25 / this.tableData.length) * 100 : 100,
                        height: 20,
                        borderColor: '#e6e6e6',
                        backgroundColor: '#fafafa',
                        fillerColor: 'rgba(42, 122, 255, 0.2)',
                        handleStyle: {
                            color: '#2A7AFF',
                            borderColor: '#2A7AFF'
                        }
                    }
                ],
                yAxis: {
                    type: 'value',
                    name: this.getEnergyUnit(this.searchForm.fuelType)
                },
                series: [
                    {
                        name: this.$t("statistics.燃耗"),
                        type: 'bar',
                        data: yAxisData,
                        barWidth: 15,
                        itemStyle: {
                            color: '#2A7AFF'
                        }
                    }
                ]
            };

            this.rankingChart.setOption(option);
        },
        updateComparisonChart(data, selectedCarNo) {
            const dates = data.map(item => item.date);
            const energyData = data.map(item => item.energyConsumption);
            const mileageData = data.map(item => item.mileage);

            const option = {
                title: {
                    text: ``,
                    left: 'center',
                    textStyle: {
                        fontSize: 14,
                        fontWeight: 'normal',
                        color: '#666'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    // axisPointer: {
                    //     type: 'cross'
                    // }
                },
                legend: {
                    data: [this.$t("statistics.燃耗"), this.$t("statistics.里程")],
                    top: 30
                },
                dataZoom: [
                    {
                        type: 'inside',
                        start: 0,
                        end: 100,
                        zoomLock: false
                    },
                    {
                        show: true,
                        type: 'slider',
                        bottom: 5,
                        start: 0,
                        end: 100,
                        height: 20,
                        borderColor: '#e6e6e6',
                        backgroundColor: '#fafafa',
                        fillerColor: 'rgba(42, 122, 255, 0.2)',
                        handleStyle: {
                            color: '#2A7AFF',
                            borderColor: '#2A7AFF'
                        }
                    }
                ],
                grid: {
                    left: '8%',
                    right: '4%',
                    bottom: '10%',
                    top: '20%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: dates,
                    boundaryGap: true,
                    axisTick: {
                        alignWithLabel: true
                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        name: "km",
                        position: 'left'
                    },
                    {
                        type: 'value',
                        name: this.getEnergyUnit(this.searchForm.fuelType),
                        position: 'left',
                        offset: 50 // 偏移量，避免两个y轴标签重叠
                    }
                ],
                series: [
                    {
                        name: this.$t("statistics.里程"),
                        type: 'bar',
                        barWidth: 15,
                        yAxisIndex: 0,
                        data: mileageData,
                        itemStyle: {
                            color: '#2A7AFF'
                        }
                    },
                    {
                        name: this.$t("statistics.燃耗"),
                        type: 'line',
                        yAxisIndex: 1,
                        data: energyData,
                        smooth: true,
                        itemStyle: {
                            color: '#FF6B6B'
                        },
                        lineStyle: {
                            width: 2
                        }
                    }
                ]
            };

            this.comparisonChart.setOption(option);
        }
    }
}
</script>

<style scoped>
.page_header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.page_title {
    font-size: 18px;
    font-weight: bold;
    color: #0F1A3A;
}

.chart_container {
    margin-bottom: 30px;
}

.chart_card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.chart_title {
    font-size: 16px;
    font-weight: bold;
    color: #0F1A3A;
    margin-bottom: 15px;
}

.table_container {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.table_title {
    font-size: 16px;
    font-weight: bold;
    color: #0F1A3A;
    margin-bottom: 15px;
}
</style>